import { useEffect, useState } from "react";
import axios from "axios";
import { Store, Filter } from "lucide-react";
import { StoreCard } from "../components/stores/StoreCard";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function StoresPage() {
  const [stores, setStores] = useState([]);
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (city) params.set("ciudad", city);
    if (status) params.set("estatus", status);
    axios.get(`${API}/stores?${params}`).then((r) => {
      setStores(r.data.stores || []);
      if (!city && !status) setCities(r.data.ciudades || []);
    }).catch(() => setStores([])).finally(() => setLoading(false));
  }, [city, status]);

  return (
    <div className="min-h-screen bg-black pt-24 pb-16" data-testid="stores-page">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-10">
          <p className="text-xs tracking-[0.3em] text-pink-400 font-bold mb-3">CIRCUITO NIRVANA</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-none mb-4">
            <span className="bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-500 bg-clip-text text-transparent">Tiendas</span>
          </h1>
          <p className="text-gray-400 text-base md:text-lg">Nuestra tienda, sede de los torneos del ranking. Abre la dirección en Google Maps o escríbenos directo por WhatsApp, Instagram y Facebook.</p>
        </div>

        {(stores.length > 1 || city || status) && <div className="flex flex-wrap items-center gap-2 mb-8" data-testid="store-filters">
          <Filter size={16} className="text-gray-500" />
          {["", "Oficial", "Aliada"].map((s) => (
            <button key={s} onClick={() => setStatus(s)} className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition ${status === s ? "bg-pink-500 text-white border-pink-500" : "border-purple-700/60 text-gray-300 hover:border-pink-500/60"}`} data-testid={`store-filter-${s || "todas"}`}>
              {s || "Todas"}
            </button>
          ))}
          <select value={city} onChange={(e) => setCity(e.target.value)} className="ml-auto px-3 py-1.5 bg-purple-900/50 border border-purple-700/50 rounded-lg text-white text-xs focus:outline-none focus:border-pink-500" data-testid="store-city-filter">
            <option value="">Todas las ciudades</option>
            {cities.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>}

        {loading ? (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">{[1, 2].map((i) => <div key={i} className="h-[520px] rounded-3xl bg-purple-900/20 animate-pulse" />)}</div>
        ) : stores.length === 0 ? (
          <div className="text-center py-20 glass-card rounded-2xl"><Store size={40} className="mx-auto text-gray-600 mb-3" /><p className="text-gray-400">No hay tiendas con esos filtros</p></div>
        ) : (
          <div className={`grid grid-cols-1 gap-8 items-start ${stores.length > 1 ? "lg:grid-cols-2" : "max-w-3xl mx-auto"}`} data-testid="stores-grid">
            {stores.map((s) => <StoreCard key={s.id} store={s} large={s.estatus === "Oficial"} />)}
          </div>
        )}

      </div>
    </div>
  );
}
